import React from 'react';
import { calendarType, displayRange, sortedBreaks } from './calendarPresentation';
import { useTranslation } from 'react-i18next';

export default function SchoolCalendarBreaks({ calendar }) {
  const { t: tr, i18n } = useTranslation();
  if (!calendar.breaks.length) return <p>{tr("calendar:noBreaksHaveBeenAddedForThisSchoolYear_132")}</p>;
  return (
    <ul className="school-calendar-breaks">
      {sortedBreaks(calendar.breaks).map(item => (
        <li key={item.breakId}><span>{item.name}</span><time>{displayRange(item, i18n.language)}</time></li>
      ))}
    </ul>
  );
}
SchoolCalendarBreaks.propTypes = { calendar: calendarType.isRequired };
